import React, { useState, useEffect } from "react";
import { authFetch } from "auth";
import { useAsyncError } from "common/hooks/useAsyncError";
import { Skeleton } from "@mui/material";

export const AssetImage = ({
  path,
  fallback = null,
  style = {
    height: "40px",
    width: "40px",
    objectFit: "cover",
  },
  skeletonProps = {
    height: "40px",
    width: "40px",
  },
  cn = "asset-image",
}) => {
  const throwError = useAsyncError();
  const [pimage, setPImage] = useState(null);
  const [shouldFallback, setShouldFallback] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const FallbackComponent = fallback;

  const loadImage = async () => {
    try {
      let res = await authFetch(path);
      let image = await res.blob();
      if (image.type !== "image/jpeg" && image.type !== "image/png")
        return setShouldFallback(true);
      setPImage(URL.createObjectURL(image));
    } catch (e) {
      console.log("error", e);
      if (fallback) {
        return setShouldFallback(true);
      }
      throwError(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => loadImage(), []);

  const skeletonStyle = {
    borderRadius: "16px",
    backgroundColor: "#333333",
    animation: "pulse 1s ease-in-out 0.5s infinite",
    ...skeletonProps,
  };

  const containerStyle = {
    position: "relative",
    height: style.height,
    width: style.width,
    overflow: "hidden",
    transition: "opacity 0.3s ease-in-out",
  };

  const imageStyle = {
    ...style,
    opacity: isLoading ? 0 : 1,
    transition: "opacity 0.3s ease-in-out",
    borderRadius: "16px",
  };

  if (shouldFallback) return FallbackComponent ? <FallbackComponent /> : null;

  return (
    <div style={containerStyle}>
      {isLoading && <Skeleton variant="rounded" style={skeletonStyle} />}
      {pimage && <img className={cn} src={pimage} style={imageStyle} />}
      <style jsx global>{`
        @keyframes pulse {
          0% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
          100% {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default AssetImage;
